import type { WebTestId } from '@frontend/test-utils';
import type { AccessibilityLabelProps } from '@frontend/web-react';
import { applyClass, mergeAndConcatClasses } from '@frontend/web-utils';
import type { Router } from '@frontend/web/router';
import { Link as TLink } from '@tanstack/react-router';
import type { LinkComponentProps } from '@tanstack/react-router/dist/esm/link';

export const NavLinkWrapper = <
  TFrom extends string = string,
  TTo extends string = '',
  TMaskFrom extends string = TFrom,
  TMaskTo extends string = '',
>({
  accessibilityLabel,
  className,
  disabled,
  disableHoverEffect = false,
  testId,
  ...props
}: AccessibilityLabelProps &
  LinkComponentProps<'a', Router, TFrom, TTo, TMaskFrom, TMaskTo> & {
    disableHoverEffect?: boolean;
    testId?: WebTestId;
  }) => {
  return (
    <TLink
      aria-label={accessibilityLabel}
      className={mergeAndConcatClasses(applyClass(!disableHoverEffect && !disabled, 'hover-opacity-effect'), className)}
      data-testid={testId}
      disabled={disabled}
      {...props}
    />
  );
};
